/* eslint-disable import/prefer-default-export */
import types from '../types/types';

export const setShippingAddress = (
  addressId,
  personalName,
  personalSecondName,
  personalLastName,
  personalEmail,
  personalPhoneType,
  personalPhoneNumber,
  shippingName,
  shippingSecondName,
  shippingLastName,
  shippingEmail,
  shippingAddressLine1,
  shippingAddressLine2,
  shippingSuburb,
  shippingCity,
  shippingState,
  shippingZipCode,
  shippingPhoneType,
  shippingPhoneNumber,
  reqFac,
  factData
) => (dispatch) => {
  dispatch({
    type: types.setShippingAddress,
    addressId,
    personalName,
    personalSecondName,
    personalLastName,
    personalEmail,
    personalPhoneType,
    personalPhoneNumber,
    shippingName,
    shippingSecondName,
    shippingLastName,
    shippingEmail,
    shippingAddressLine1,
    shippingAddressLine2,
    shippingSuburb,
    shippingCity,
    shippingState,
    shippingZipCode,
    shippingPhoneType,
    shippingPhoneNumber,
    reqFac,
    factData,
  });
};
